import { MenuApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const labelApi = {
  index: wrap(MenuApi, MenuApi.prototype.indexLabelList),
};
